(function () {
  'use strict';

  const STORAGE_KEY = 'every-rise:recently-viewed-handles';
  const MAX_ITEMS = 12;

  function getViewedHandles() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveViewedHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
  }

  function currentProductHandle() {
    const match = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-_]+)/);
    return match ? match[1] : null;
  }

  function trackCurrentProduct() {
    const handle = currentProductHandle();
    if (!handle) return;
    let handles = getViewedHandles().filter((h) => h !== handle);
    handles.unshift(handle);
    saveViewedHandles(handles.slice(0, MAX_ITEMS));
  }

  function buildCardHtml(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const price = (product.price / 100).toFixed(2);
    return `
      <div class="product-grid__item">
        <div class="product-card">
          <a href="/products/${product.handle}" class="product-card__link">
            <div class="product-card__image-wrap product-card__image-wrap--portrait">
              ${image ? `<img class="product-card__image product-card__image--primary" src="${image}" alt="${product.title}" width="700" height="875" loading="lazy">` : ''}
            </div>
            <div class="product-card__info">
              <h3 class="product-card__title">${product.title}</h3>
              <div class="price"><span class="price__regular">$${price}</span></div>
            </div>
          </a>
        </div>
      </div>`;
  }

  function renderRecentlyViewed() {
    const section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const excludeHandle = currentProductHandle();
    const handles = getViewedHandles()
      .filter((h) => h !== excludeHandle)
      .slice(0, 4);

    if (!handles.length) return;

    Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((res) => (res.ok ? res.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      const valid = products.filter(Boolean);
      if (!valid.length) return;
      grid.innerHTML = valid.map(buildCardHtml).join('');
      section.hidden = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    trackCurrentProduct();
    renderRecentlyViewed();
  });
})();
